<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">TSP Profile</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button *ngIf="!this.reactivate" class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
                  data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a (click)="goToApprovalInformation()">Approval Information</a>
            </li>
            <li class="usa-nav__submenu-item">
              <a (click)="gotToAgencyUser()"> User List </a>
            </li>
            <li class="usa-nav__submenu-item">
              <a routerLink="/agencytspsearch"> Search </a>
            </li>
            <li class="usa-nav__submenu-item">
              <a (click)="gotoCarrierContactInfo()"> Shipment Booking Contact </a>
            </li>
            <!--
            <li class="usa-nav__submenu-item">
              <a (click)="gotoNotificationsPrefs()"> Notification Preferences </a>
            </li>
            -->
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div class="grid-row">
    <div class="usa-alert usa-alert--info usa-alert--no-icon"
         *ngIf="saveSuccessful  && disabled === true && reactivated === false">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          TSP profile has been updated successfully
        </p>
      </div>
    </div>
    <div class="usa-alert usa-alert--info usa-alert--no-icon"
         *ngIf="saveSuccessful  && disabled === false && reactivated === false">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          TSP profile has been added successfully
        </p>
      </div>
    </div>
    <div class="usa-alert usa-alert--info usa-alert--no-icon" *ngIf="reactivated">
      <div class="usa-alert__body">
        <p class="usa-alert__text">
          TSP has been reactivated successfully
        </p>
      </div>
    </div>
  </div>
  <form [formGroup]="carrierProfileForm" #carrierProfForm="ngForm">
    <fieldset class="usa-fieldset">
      <legend class="usa-legend usa-legend--medium"></legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="scac" class="usa-label">SCAC<abbr title="required"
                                                        class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" oninput="this.value = this.value.toUpperCase()"
                 id="scac" maxlength="4" formControlName="scac" class="usa-input" (change)="onChangeCheckSCAC()">
          <div
            *ngIf="this.carrierProfileForm.get('scac').invalid && (this.carrierProfileForm.get('scac').touched
               || this.carrierProfileForm.get('scac').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              SCAC is required
            </small>
          </div>

        </div>
        <div class="grid-col-4">
          <label for="scacName" class="usa-label">TSP Name<abbr title="required"
                                                                class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text"
                 id="scacName" formControlName="scacName" class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('scacName').invalid && (this.carrierProfileForm.get('scacName').touched
               || this.carrierProfileForm.get('scacName').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              TSP Name is required
            </small>
          </div>

        </div>
        <div *ngIf = "isFrtOnly" class="grid-col-3 border-left-1px border-top-1px border-right-1px border-bottom-1px define-padding-left">
          <label for="scacExpDate" class="usa-label">
            <span class="text-bold">SCAC Code Expiration Date :</span>
            {{organization.scacExpDate == null ? 'Not Available' : organization.scacExpDate | date:'MM/dd/yyyy'}}
          </label>
          <label for="insurExpDate" class="usa-label">
            <span class="text-bold">Liability Insurance Expiration Date :</span>
            {{organization.insurExpDate == null ? 'Not Available' : organization.insurExpDate | date:'MM/dd/yyyy'}}
          </label>
        </div>
      </div>
      <div class="grid-row grid-gap">
       
        <div class="grid-col-4">
          <label for="uniqueEntityId" class="usa-label">SAM Unique Entity Identifier (UEI)<abbr title="required"
                                                                                                class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="uniqueEntityId"
                 formControlName="uniqueEntityId"
                 maxlength="15" class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('uniqueEntityId').hasError('required')  && (this.carrierProfileForm.get('uniqueEntityId').touched
               || this.carrierProfileForm.get('uniqueEntityId').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              SAM unique entity identifier is required
            </small>
          </div>
        </div>
        <div class="grid-col-4">
          <label for="samEntityName" class="usa-label">SAM Entity Name<abbr title="required"
                                                                            class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="samEntityName"
                 formControlName="samEntityName" maxlength="100"
                 class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('samEntityName').hasError('required')  && (this.carrierProfileForm.get('samEntityName').touched
               || this.carrierProfileForm.get('samEntityName').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              SAM entity name is required
            </small>
          </div>
        </div>
        <div class="grid-col-4">
          <label for="samUeiExpDate" class="usa-label">SAM UEI Expiration Date<abbr title="required"
                                                                                    class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="samUeiExpDate" formControlName="samUeiExpDate" class="usa-input" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" (bsValueChange)="samDateChange($event)" placeholder="MM/dd/yyyy" bsDatepicker>
          <div class="text-danger" *ngIf="this.carrierProfileForm.get('samUeiExpDate').touched && this.carrierProfileForm.get('samUeiExpDate').hasError('required')">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Expiration Date is required
          </div>
          <div class="text-danger" *ngIf="this.carrierProfileForm.get('samUeiExpDate').touched && samUeiDateError">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
            </svg> Expiration Date should be a future date
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        
        <div class="grid-col-4">
          <label for="samDbaName" class="usa-label">SAM DBA Name</label>
          <input type="text"
                 id="samDbaName" formControlName="samDbaName" class="usa-input"
                 size='100' maxlength="100">
        </div>
        <div class="grid-col-4">
          <label for="shipmentTrackingUrl" class="usa-label">Shipment Tracking URL</label>
          <input type="text" id="shipmentTrackingUrl" formControlName="shipmentTrackingUrl" class="usa-input" maxlength="500" placeholder="https://..." inputmode="url" autocomplete="off">
          <div *ngIf="this.carrierProfileForm.get('shipmentTrackingUrl')?.hasError('maxlength')">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              URL is too long
            </small>
          </div>
        </div>
        <div class="grid-col-4 padding-top-5">
          <label class="switch">
            <input type="checkbox" formControlName="smartWayId"/>
            <span class="slider round"></span>
          </label>
          <small class="fa fa-leaf green-500 padding-left-2">EPA SmartWay TSP?</small>
        </div>
      </div>
      <hr>
      <legend class="usa-legend usa-legend--medium">Authorized Official</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="firstName" class="usa-label">First Name<abbr title="required"
                                                                   class="usa-hint usa-hint--required">*</abbr>
          </label> <input type="text"
                          id="firstName"
                          formControlName="firstName"
                          class="usa-input"
                          size='35'
                          maxlength='35'>
          <div
            *ngIf="this.carrierProfileForm.get('firstName').hasError('required')  && (this.carrierProfileForm.get('firstName').touched
               || this.carrierProfileForm.get('firstName').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              First Name is required
            </small>
          </div>
          <div
            *ngIf="this.carrierProfileForm.get('firstName').hasError('pattern')">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              First Name is invalid.
            </small>
          </div>

        </div>
        <div class="grid-col-4">
          <label for="middle_name" class="usa-label">Middle Initial</label> <input
          type="text" id="middle_name" formControlName="middleInitial"
          class="usa-input" size='1' maxlength='1'>
        </div>
        <div class="grid-col-4">
          <label for="last_name" class="usa-label">Last Name<abbr title="required"
                                                                  class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text"
                 id="last_name"
                 formControlName="lastName"
                 class="usa-input"
                 size='35'
                 maxlength='35'>
          <div
            *ngIf="this.carrierProfileForm.get('lastName').hasError('required') && (this.carrierProfileForm.get('lastName').touched
               || this.carrierProfileForm.get('lastName').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Last Name is required
            </small>
          </div>
          <div
            *ngIf="this.carrierProfileForm.get('lastName').hasError('pattern')">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Last Name is invalid.
            </small>
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="title" class="usa-label">Title<abbr title="required"
                                                          class="usa-hint usa-hint--required">*</abbr></label> <input
          type="text" id="title"
          formControlName="title"
          class="usa-input" size='45'
          maxlength='45'>
          <div
            *ngIf="this.carrierProfileForm.get('title').invalid && (this.carrierProfileForm.get('title').touched
               || this.carrierProfileForm.get('title').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Title is required
            </small>
          </div>
        </div>
        <div class="grid-col-4">
          <label for="email" class="usa-label">Email<abbr title="required"
                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="email"
                 formControlName="email"
                 class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('email').invalid && (this.carrierProfileForm.get('email').touched
               || this.carrierProfileForm.get('email').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Email is required
            </small>
          </div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="phone" class="usa-label">Phone<abbr title="required"
                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="phone"
                 appNumbersOnly
                 formControlName="phone"
                 maxlength="15" class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('phone').invalid && (this.carrierProfileForm.get('phone').touched
               || this.carrierProfileForm.get('phone').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Phone is required
            </small>
          </div>
          <div
            *ngIf="this.carrierProfileForm.get('phone').hasError('minlength')">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Phone Number should be at least 10 digits long
            </small>
          </div>
          <div
            *ngIf="this.carrierProfileForm.get('phone').hasError('numericsOnly')">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Phone Number is invalid - should be all numeric, no dashes, no
              spaces
            </small>
          </div>
        </div>
        <div class="grid-col-4">
          <label for="phone_ext" class="usa-label">Ext</label> <input type="text" appNumbersOnly
                                                                      id="phone_ext" formControlName="phoneExtension"
                                                                      class="usa-input"
                                                                      [maxlength]="10">
        </div>
      </div>
      <hr>
      <legend class="usa-legend usa-legend--medium">Secondary Contact</legend>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="secondaryContFirstName" class="usa-label">First Name
          </label> <input type="text"
                          id="secondaryContFirstName"
                          formControlName="secondaryContFirstName"
                          class="usa-input"
                          size='35'
                          maxlength='35'>
        </div>
        <div class="grid-col-4">
          <label for="secondaryContMiddleInitial" class="usa-label">Middle Initial</label> <input
          type="text" id="secondaryContMiddleInitial" formControlName="secondaryContMiddleInitial"
          class="usa-input" size='1' maxlength='1'>
        </div>
        <div class="grid-col-4">
          <label for="secondaryContLastName" class="usa-label">Last Name</label>
          <input type="text"
                 id="secondaryContLastName"
                 formControlName="secondaryContLastName"
                 class="usa-input"
                 size='35'
                 maxlength='35'>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="secondaryContTitle" class="usa-label">Title</label> <input
          type="text" id="secondaryContTitle"
          formControlName="secondaryContTitle"
          class="usa-input" size='45'
          maxlength='45'>
        </div>
        <div class="grid-col-4">
          <label for="secondaryContEmail" class="usa-label">Email</label>
          <input type="text" id="secondaryContEmail"
                 formControlName="secondaryContEmail"
                 class="usa-input">
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="secondaryContPhone" class="usa-label">Phone</label>
          <input type="text" id="secondaryContPhone"
                 appNumbersOnly
                 formControlName="secondaryContPhone"
                 maxlength="15" class="usa-input">
        </div>
        <div class="grid-col-4">
          <label for="secondaryContPhoneExt" class="usa-label">Ext</label> <input type="text" appNumbersOnly
                                                                                  id="secondaryContPhoneExt" formControlName="secondaryContPhoneExt"
                                                                                  class="usa-input"
                                                                                  [maxlength]="10">
        </div>
      </div>
      <hr>
      <legend class="usa-legend usa-legend--medium">Mailing Address</legend>
      <div class="grid-row">
        <div class="grid-col-4" *ngIf="isCountrySelectedUSA">
          <ng-template #customItemTemplate let-model="item">{{model.cityName}},
            {{model.stateAbbrev}} {{model.zipCode}}
          </ng-template>
          <label for="OriginSearchString" class="usa-label">Search by City or Zip: </label> <input
          id="OriginSearchString" class="usa-input"
          formControlName="asyncOriginSearchString"
          [typeaheadAsync]="true" [typeahead]="dataSourceOrigin"
          (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
          (typeaheadOnSelect)="typeaheadOriginOnSelect($event, true)"
          typeaheadOptionField="cityName"
          [typeaheadItemTemplate]="customItemTemplate"
          [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
          [typeaheadOptionsInScrollableView]="10"
          [typeaheadOptionsLimit]="100"
          placeholder="Type a location or zip">
          <div *ngIf="typeaheadLoading">Loading...</div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="address" class="usa-label">Address<abbr title="required"
                                                              class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text"
                 id="address"
                 formControlName="addressLine1"
                 class="usa-input">
          <div
            *ngIf="this.carrierProfileForm.get('addressLine1').invalid && (this.carrierProfileForm.get('addressLine1').touched
               || this.carrierProfileForm.get('addressLine1').dirty)">
            <small class="text-danger"> <span class="fa fa-warning"></span>
              Address is required
            </small>
          </div>
        </div>
        <div class="grid-col-4">
          <label for="address_2" class="usa-label">Address 2</label> <input type="text"
                                                                            id="address_2"
                                                                            formControlName="addressLine2"
                                                                            class="usa-input">

        </div>
        <div class="grid-col-4">
          <label for="zip" class="usa-label">Zip Code<abbr title="required" *ngIf="this.isCountrySelectedUSA"
                                                           class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="zip" formControlName="zip" readonly
                 id="zip"
                 maxlength="6" class="usa-input">
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="city" class="usa-label">City<abbr title="required" *ngIf="this.isCountrySelectedUSA"
                                                        class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="city" formControlName="city" class="usa-input" readonly
                 size='45' maxlength='45' id="city">
        </div>
        <div class="grid-col-4">
          <label for="state" class="usa-label">State<abbr title="required" *ngIf="this.isCountrySelectedUSA"
                                                          class="usa-hint usa-hint--required">*</abbr></label>
          <input type="text" id="state" formControlName="state" class="usa-input" readonly
                 id="state">
        </div>
        <div class="grid-col-4">
          <label for="country" class="usa-label">Country<abbr title="required"
                                                              class="usa-hint usa-hint--required">*</abbr></label>
          <select id="country"
                  class="usa-select"
                  formControlName="country"
                  title="reporting_country"
                  (change)="onCountryChange()"
                  name="country">
            <option [value]='null' selected disabled>Choose...</option>
            <option *ngFor='let c of countryList'
                    [value]="c.stateCountryId">{{c.stateCountryName}}</option>
          </select>
        </div>
      </div>
      <hr>
      <legend class="usa-legend usa-legend--medium">Physical Address</legend>
      <div class="grid-row">
        <div class="grid-col-4" *ngIf="isCountrySelectedUSA">
          <ng-template #customItemTemplate let-model="item">{{model.cityName}},
            {{model.stateAbbrev}} {{model.zipCode}}
          </ng-template>
          <label for="phAsyncOriginSearchString" class="usa-label">Search by City or Zip: </label> <input
          id="phAsyncOriginSearchString" class="usa-input"
          formControlName="phAsyncOriginSearchString"
          [typeaheadAsync]="true" [typeahead]="secondaryDataSourceOrigin"
          (typeaheadLoading)="changeTypeaheadOriginLoading($event)"
          (typeaheadOnSelect)="typeaheadOriginOnSelect($event, false)"
          typeaheadOptionField="cityName"
          [typeaheadItemTemplate]="customItemTemplate"
          [typeaheadWaitMs]="1000" [typeaheadScrollable]="true"
          [typeaheadOptionsInScrollableView]="10"
          [typeaheadOptionsLimit]="100"
          placeholder="Type a location or zip">
          <div *ngIf="typeaheadLoading">Loading...</div>
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="physicalAddressLine1" class="usa-label">Address</label>
          <input type="text"
                 id="physicalAddressLine1"
                 formControlName="physicalAddressLine1"
                 class="usa-input">
        </div>
        <div class="grid-col-4">
          <label for="physicalAddressLine2" class="usa-label">Address 2</label>
          <input type="text"
                 id="physicalAddressLine2"
                 formControlName="physicalAddressLine2"
                 class="usa-input">
        </div>
        <div class="grid-col-4">
          <label for="zip" class="usa-label">Zip Code</label>
          <input type="text" id="physicalZip" formControlName="physicalZip" readonly
                 id="physicalZip"
                 maxlength="6" class="usa-input">
        </div>
      </div>
      <div class="grid-row grid-gap">
        <div class="grid-col-4">
          <label for="physicalCity" class="usa-label">City</label>
          <input type="text" id="physicalCity" formControlName="physicalCity" class="usa-input" readonly
                 size='45' maxlength='45' id="physicalCity">
        </div>
        <div class="grid-col-4">
          <label for="physicalState" class="usa-label">State</label>
          <input type="text" id="physicalState" formControlName="physicalState" class="usa-input" readonly
                 id="physicalState">
        </div>
        <div class="grid-col-4">
          <label for="physicalCountry" class="usa-label">Country</label>
          <select id="physicalCountry"
                  class="usa-select"
                  formControlName="physicalCountry"
                  title="physicalCountry"
                  (change)="onSecondaryCountryChange()"
                  name="physicalCountry">
            <option [value]='null' selected disabled>Choose...</option>
            <option *ngFor='let c of countryList'
                    [value]="c.stateCountryId">{{c.stateCountryName}}</option>
          </select>
        </div>
      </div>

      <hr>
      <legend class="usa-legend usa-legend--medium">Notification Preferences</legend>
      <div class="grid-row">
        <div class="grid-col-4">
          <button type="button" class="usa-button" (click) = "onNotificationPreference()" > View Notification Preferences</button>
        </div>
      </div>
      <hr>
      <div class="grid-row">
        <div class="grid-col-4">
          <label class="usa-label">Permissions<abbr title="required"
                                                    class="usa-hint usa-hint&#45;&#45;required">*</abbr>:
            {{permissionAccessValue}}
          </label>
        </div>
        <div class="grid-col-4 margin-top-1em" *ngIf="showRfsp">
          <div class="usa-checkbox">
            <input
              class="usa-checkbox__input"
              id="rfsp"
              formControlName="rfsp"
              type="checkbox"/>
            <label class="usa-checkbox__label" for="rfsp">RFSP</label>
          </div>
        </div>
      </div>
      <div class="grid-col-5" *ngIf="!this.newProfile">
        <label for="updateMessage" class="usa-label">Update Notes (Maximum 250 chars)<abbr title="required" class="usa-hint usa-hint--required">*</abbr>
          <button type="button" class="usa-button margin-left-2"  (click) = "messageHistoryModal()" > Notes History</button>
        </label>
        <div class="usa-alert usa-alert--warning usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              The notes entered below will be included on the notification being sent to the Authorized Official.
            </p>
          </div>
        </div>

        <textarea class="usa-textarea"  id="updateMessage"
                  formControlName="updateMessage" maxlength="250">
        </textarea>
        <div
          *ngIf="this.carrierProfileForm.get('updateMessage').invalid && (this.carrierProfileForm.get('updateMessage').touched
             || this.carrierProfileForm.get('updateMessage').dirty)">
          <small class="text-danger"> <span class="fa fa-warning"></span>
            Update Note is required
          </small>
        </div>
      </div>
      <div class="grid-row" *ngIf="showTspCategory">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
        <label for="sro" class="usa-label">TSP Category</label>
        <select multiple id="sro" class="usa-select maxw-full define-height-usa-select" formControlName="tspCategory" size="10" (change)="categoryChange($event.target.value)">
          <option value='' selected disabled>Choose...</option>
          <option *ngFor="let category of tspCategory" [value]="category.value">
            {{category.name}}
          </option>
        </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 text-center define-margin-x-y-auto">
          <button type="button" class="usa-button width-60" (click)="moveItems(this.carrierProfileForm.value.tspCategory)">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
            </svg>
          </button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="assigned_accessorials" class="usa-label">TSP Category Assigned</label>
          <select size="5" class="usa-select define-height-usa-select maxw-full" formControlName="assignedTspCategory" id="assigned_tsp_cat">
            <option *ngFor="let tspCat of assignedTspCatList; let i = index"
            (dblclick)="handleAccMultiDropdown(i)" >
              {{tspCat.name}}
            </option>
          </select>
          <div style="font-weight: 700;">Double click on item to remove from this list.</div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1"></div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="sro" class="usa-label">TSP Service Offerings</label>
          <select multiple id="sro" class="usa-select maxw-full define-height-usa-select" formControlName="tspServiceOffering" size="10" (change)="categoryChange($event.target.value)">
            <option value='' selected disabled>Choose...</option>
            <option *ngFor="let category of tspServiceOffering" [value]="category.frtTspServiceOfferingsId">
              {{category.serviceDescription}}
            </option>
          </select>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-1 desktop:grid-col-1 text-center define-margin-x-y-auto">
          <button type="button" class="usa-button width-60" (click)="moveOfferings(this.carrierProfileForm.value.tspServiceOffering)">
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#arrow_forward"></use>
            </svg>
          </button>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-2 desktop:grid-col-2">
          <label for="assigned_tsp_offering" class="usa-label">TSP Service Offerings Assigned</label>
          <select size="5" class="usa-select define-height-usa-select maxw-full" formControlName="assignedTspOfferings" id="assigned_tsp_offering">
            <option *ngFor="let tspCat of assignedTspOfferingList; let i = index"
                    (dblclick)="handleOfferingsMultiDropdown(i)" >
              {{tspCat.serviceDescription}}
            </option>
          </select>
          <div style="font-weight: 700;">Double click on item to remove from this list.</div>
        </div>
      </div>
      <div class="grid-row mt-4">
        <button type="button" class="usa-button"
          [disabled]="carrierProfileForm.invalid || this.saveSuccessful || samUeiDateError || (!this.newProfile && !(this.carrierProfileForm.get('updateMessage').value && this.carrierProfileForm.get('updateMessage').value.trim().length > 0))" *ngIf="!this.reactivate"
          (click)="saveOrganization()">Save
        </button>
        <!--<button type="button" class="usa-button usa-button&#45;&#45;outline" *ngIf="!this.reactivate && !this.newProfile"
                (click)="deleteOrgData()">Deactivate TSP
        </button>-->
        <button type="button" class="usa-button" *ngIf="this.reactivate"  [disabled]="carrierProfileForm.invalid || this.saveSuccessful || samUeiDateError " (click)="reactivate1()">
          Reactivate TSP
        </button>
        <button type="button"  class="usa-button usa-button--secondary" *ngIf="!this.newProfile && !this.reactivate" (click)="deleteOrgData()" >Revoke TSP for All Approval Types</button>
        <button type="button" class="usa-button" *ngIf="!this.newProfile" (click)="viewAuditTrial()">View Audit Trail</button>
      </div>
    </fieldset>
  </form>
</div>
